var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"image-link",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.imageSrc,"width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }